module.exports = __webpack_public_path__ + "img/app-gallery.3050eaa8.svg";